export default "__VITE_ASSET__610bb01f__"